import axios from "axios";
import initializeAxios from "../util/Axios";

class ItemServices {
    constructor() {
        initializeAxios();
    }

    async getItems({ searchTerm, isActive, pageIndex, pageSize }) {
        const response = await axios.get("/api/items", {
            params: {
                searchTerm,
                isActive,
                pageIndex,
                pageSize
            }
        });

        return response.data;
    }

    async addItem({
        categoryName,
        systemName,
        category,
        slug,
        keywords,
        title,
        description,
        shortDescription,
        image,
        section
    }) {
        const response = await axios.post("/api/item/add", {
            categoryName,
            systemName,
            category,
            slug,
            keywords,
            title,
            description,
            shortDescription,
            image,
            section
        });

        return response;
    }

    async editItem({
        itemId,
        categoryName,
        systemName,
        category,
        slug,
        keywords,
        title,
        description,
        shortDescription,
        image,
        section
    }) {
        const response = await axios.put("/api/item/update", {
            itemId,
            categoryName,
            systemName,
            category,
            slug,
            keywords,
            title,
            description,
            shortDescription,
            image,
            section
        });

        return response;
    }

    async deleteItem(itemId, isActive) {
        const response = await axios.put("/api/item/delete", {
            itemId,
            isActive
        });

        return response.data;
    }

    async removeBanner(bannerId) {
        const response = await axios.get("/api/banner/delete", {
            params: {
                bannerId,
            },
        });
        return response;
    }

    async getItemDetails(id) {
        const response = await axios.get("/api/item/details", {
            params: {
                itemId: id
            }
        });

        return response;
    }

    async uploadToS3(data) {
        const formData = new FormData();
        for (let key in data) {
            formData.append(key, data[key]);
        }
        const response = await axios.post("/api/util/uploadimage", formData);
        return response.data;
    }

    async getAllCategoryList() {
        const response = await axios.get("/api/allcategorieslist");
        return response.data;
    }
}

export default new ItemServices();